const initialState = {
  lastProduct: null,
}
// eslint-disable-next-line
export default (state = initialState, action) => {
  switch (action.type) {
    case "LAST_PRODUCT":
      return action.payload
    default:
      return state
  }
};
export const LastProduct = state => state
